//-----------------------Système bouton---------------------

const selectorMenu = document.querySelectorAll(".slctMenu");
if (selectorMenu){
  for( let selector of selectorMenu){
    selector.addEventListener('click', (e) =>{
      let selectedSelector = document.querySelector(".selectedTab");
      if(selectedSelector){
        selectedSelector.classList.remove("selectedTab");
      }
      let cleanTab = document.querySelector(".selectedDescription");
      if (cleanTab){
        cleanTab.classList.remove("selectedDescription");
      }
      console.log("Bouton sélectioné : " + selector.dataset.order);
      let selectedButton = selector.dataset.order;
      let selectedTab = document.body.querySelector(`.descriptionHidden[data-txtorder="${selectedButton}"]`);
      selectedTab.classList.add("selectedDescription");
      selector.classList.add("selectedTab");
    });
  };
}

let GenreSelectors = document.body.querySelectorAll(".genreSelectors");
  for(let GenreSelector of GenreSelectors){
    GenreSelector.addEventListener("click", (e) => {
      CurrentGenre = GenreSelector.dataset.genre;
      localStorage.setItem("Genre", CurrentGenre);
      console.log(localStorage.getItem("Genre"));
    });
};

let GetPageType = document.body.querySelector(".mainContainer");
CurrentPageType = GetPageType.dataset.page;
if(CurrentPageType == "Genre") {
  let selectedGenre = localStorage.getItem("Genre");
  let displayGenre = document.querySelector(`[data-genre=${selectedGenre}]`);
  displayGenre.classList.add("selectedCategory");

  let saveClasses = document.body.querySelectorAll(".classSelector");
  for(let saveClass of saveClasses){
    saveClass.addEventListener("click", () => {
      let firstClass = saveClass.dataset.class;
      localStorage.setItem("firstClass", firstClass);
    });
  };
}else if(CurrentPageType == "Classe"){
  let chosenClass = localStorage.getItem("firstClass");
  let displayClass = document.querySelector(`[data-class=${chosenClass}]`);
  displayClass.classList.add("selectedCategory");
}else if(CurrentPageType == "Roll"){

    //----------------------Système de Roll----------------------

    let roll = document.querySelector('.roll');
    if(roll){
    roll.addEventListener("click", triggerRoll);
    function getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min +1)) + min;
        };
      }
    // Il faut réussir à stocker les nombres généré dans cet Array
    var rollResults = [];
    var statTotalRoll = [];
    var distributedRoll = [];
    var raceStats = [];

    //------------------Répartition automatisée:-------------------------    

    async function fetchClass() {
      const response = await fetch('assets/data/data.json');
      const classes = await response.json();
      //console.log(classes);
      //console.log(selectedClass);
      let stats = classes[selectedClass];
      
      for (let i = 0; i < 6; i++){
        //Je veux sélectionné le data attribute correspondant à celui de l'array et y push la bonne stat.
        //console.log(stats[i]);
        //console.log(rollResults[i]);
        let statElement = document.querySelector(`[data-stat=${stats[i]}]`);
        let GetRolledStats =  JSON.parse(localStorage.getItem("rollsValue"));
        statElement.innerHTML = GetRolledStats[i];
      };

      //Je stocke les statistiques une fois réparties.

      let sortedValues = document.body.querySelectorAll(".sortedValues");
      for ( let sortedValue of sortedValues){
        let sortedValueString = sortedValue.innerHTML;
        distributedRoll.push(sortedValueString);
      }
      localStorage.setItem("sortedStats", JSON.stringify(distributedRoll));
      console.log(localStorage.getItem("firstClass"));
      console.log(JSON.parse(localStorage.getItem("sortedStats")));
    }

    function triggerRoll(e){
      e.preventDefault();
      //console.log("Triggered");
    //Je vide l'array précédement généré
        rollResults = [];
      
    // Je génère 6 Chiffres entre 3 et 18 et je les push dans l'array.
      for (let pas = 0; pas < 6; pas++){
        // Code pour simuler les 4d6 - 1
          for (let pas = 0; pas < 4; pas++){
                var statRoll = getRandomIntInclusive(1,6);
                statTotalRoll.push(statRoll);
          };
          statTotalRoll.sort(function(a, b) {
            return a - b;
          });
        let statCorrectedRoll = statTotalRoll[1] + statTotalRoll[2] + statTotalRoll[3];
        //console.log(statTotalRoll);
        //console.log(statCorrectedRoll);
        statTotalRoll = [];
        rollResults.push(statCorrectedRoll);
        rollResults.sort(function(a, b) {
          return a - b;
        });
        //localStorage.setItem("rollsValue", rollResults);
        localStorage.setItem("rollsValue", JSON.stringify(rollResults));
      }

      fetchClass();


      let toRaceBtn = document.body.querySelector(".toRace__link");
        toRaceBtn.classList.add("toRace__link--display");
      let rollSafari = document.querySelector(".roll");
        rollSafari.classList.add("roll--hide");
    };

    //------------------Empecher de roll 2 fois-------------------------
    let alreadyRolled =  JSON.parse(localStorage.getItem("sortedStats"));
    if(alreadyRolled && roll){
      console.log("roll déjà effectué.");
      let warningText = document.body.querySelector('#alreadyRolled');
      let toRaceBtn = document.body.querySelector(".toRace__link");
      fetchClass();
      warningText.classList.add('showWarning');
      toRaceBtn.classList.add("toRace__link--display");
      roll.classList.add("roll--hide");
    }


}else if(CurrentPageType == "Index"){
  let raceFinale = localStorage.getItem("raceSelected");
  if(raceFinale){
    let firstTime = document.querySelector(".firstTimeApp");
    let NotFirstTIme = document.querySelector(".BackToSynth");
    firstTime.classList.add("descriptionHidden");
    NotFirstTIme.classList.remove("descriptionHidden");
  };
  let ResetButton = document.querySelector('.resetApp');
  ResetButton.addEventListener('click', (e) =>{
      localStorage.clear();
  });
};



let ClassSelectors = document.body.querySelectorAll(".subclassSelector");
  for(let ClassSelector of ClassSelectors){
    ClassSelector.addEventListener("click", ()=>{
      CurrentSubClass = ClassSelector.dataset.subclass;
      localStorage.setItem("Sous-Classe", CurrentSubClass);
    });
};

var selectedClass = localStorage.getItem("Sous-Classe");

//--------------- Boost de race ---------------------------

let raceSelectors = document.querySelectorAll(".raceSelector");

for(let raceSelector of raceSelectors){
  raceSelector.addEventListener("click", ()=>{

    let currentStatsStr = JSON.parse(localStorage.getItem("sortedStats"));
    const currentStats = currentStatsStr.map(str => {
      return Number(str);
    });
    console.log(currentStats);
    let selectedRace = raceSelector.dataset.race;
    localStorage.setItem("raceSelected", selectedRace);
    console.log(localStorage.getItem("raceSelected"));

    if(selectedRace == "Humain"){
      raceStats = [];
      for (let pas = 0; pas < 6; pas++){
        
         let humanRaceStat = currentStats[pas] + 1;
         raceStats.push(humanRaceStat);
      }
      localStorage.setItem("RaceStats", JSON.stringify(raceStats));
      console.log(JSON.parse(localStorage.getItem("RaceStats")));
    } else if(selectedRace == "Drakeide"){
      raceStats = currentStats;
      raceStats[0] += 2;
      raceStats[5] +=1;
      localStorage.setItem("RaceStats", JSON.stringify(raceStats));
      console.log(JSON.parse(localStorage.getItem("RaceStats")));
    } else if(selectedRace == "Elfe des bois"){
      raceStats = currentStats;
      raceStats[1] += 2;
      raceStats[4] +=1;
      localStorage.setItem("RaceStats", JSON.stringify(raceStats));
      console.log(JSON.parse(localStorage.getItem("RaceStats")));
    } else if(selectedRace == "Gnome des forêts"){
      raceStats = currentStats;
      raceStats[3] += 2;
      raceStats[1] +=1;
      localStorage.setItem("RaceStats", JSON.stringify(raceStats));
      console.log(JSON.parse(localStorage.getItem("RaceStats")));
    } else if(selectedRace == "Nain des montagnes"){
      raceStats = currentStats;
      raceStats[0] += 2;
      raceStats[2] +=2;
      localStorage.setItem("RaceStats", JSON.stringify(raceStats));
      console.log(JSON.parse(localStorage.getItem("RaceStats")));
    }
    // J'affiche les statistiques.
    var raceStatsUL = document.querySelectorAll(".RaceStatDisplay");
    for(let individualUL of raceStatsUL){
      individualUL.innerHTML = "";

      for( w=0 ; w <6 ; w++){
        let statsName = ["Force", "Dextérité", "Constitution", "Intélligence", "Sagesse", "Charisme"];
        const li = document.createElement('li');
        li.innerHTML = statsName[w] + " :  " + raceStats[w];
        individualUL.appendChild(li);
      }
    }

  });
};

//--------------------------Synthèse--------------------------------

let synthClass = document.querySelector('.synthclass');
if(synthClass){
  let synthSubClass = document.querySelector('.synthSubClass');
  let synthRace = document.querySelector('.synthRace')

  let classeFinale = localStorage.getItem("firstClass");
  let subClasseFinale = localStorage.getItem("Sous-Classe");
  let raceFinale = localStorage.getItem("raceSelected");
  let raceStats = JSON.parse(localStorage.getItem("RaceStats"));
  console.log("Stats héritée :" + raceStats);
  synthClass.innerHTML = classeFinale;
  synthSubClass.innerHTML = subClasseFinale;
  synthRace.innerHTML = raceFinale;

  var raceStatsUL = document.querySelectorAll(".RaceStatDisplay");
  for(let individualUL of raceStatsUL){
    individualUL.innerHTML = "";

    for( w=0 ; w <6 ; w++){
      const li = document.createElement('li');
      let statsName = ["Force", "Dextérité", "Constitution", "Intélligence", "Sagesse", "Charisme"];
      li.innerHTML = statsName[w] + " :  " + raceStats[w];
      individualUL.appendChild(li);
    }
  }

};